import api from "./api";

// store our JWT in LS and set axios headers if we do have a token

const setAuthToken = (token) => {
  // console.log("token", token);
  if (token) {
    api.defaults.headers.common = { Authorization: `Bearer ${token}` };
    localStorage.setItem(process.env.REACT_APP_TOKEN, token);
  } else {
    delete api.defaults.headers.common["Authorization"];
    localStorage.removeItem(process.env.REACT_APP_TOKEN);
  }
};

export default setAuthToken;
